module.exports = __webpack_public_path__ + "static/media/ca-poppy.23b51d16.jpeg";